import BaseModelAPI from '../BaseModelAPI';

export default class ProductionQualityInspectionVisualList extends BaseModelAPI {

	static entity = 'productionqualityinspectionvisuallist'
	static entityName = 'productionqualityinspectionvisual';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
